<div class="title accordion-title" (click)="onToggle()" [attr.data-id]="employee.id">
    <!--Plus Icon-->
    <div *ngIf="employee.reports && employee.reports.length" class="plus-icon"><i class="ui icon plus"></i></div>

    <!--Avatar-->
    <app-avatar *ngIf="showPhoto" [employee]="employee" size="medium" class="margin-right-2"> </app-avatar>

    <!--Details-->
    <div class="details">
        <!--Name-->
        <ng-container *ngIf="showName">
            <strong>{{ employee?.fullName }}</strong>
            <br />
        </ng-container>
        <!--Show Job Position-->
        <ng-container *ngIf="showPosition">
            <span>{{ employee?.job?.title }}</span>
            <br />
        </ng-container>
        <!--Show Department Name-->
        <ng-container *ngIf="showDepartment">
            <span>{{ employee?.department?.name }}</span>
            <br />
        </ng-container>
    </div>

    <!--Dot menu-->
    <div class="ui dropdown" (click)="$event.stopPropagation()">
        <mat-icon svgIcon="meatballVertical"></mat-icon>
        <div class="menu">
            <div class="item" [routerLink]="['/employees/directory', employee.id]">
                {{ 'sidebar.profile' | translate }}
            </div>
            <div class="item disabled">{{ employee?.account?.email }}</div>
            <div class="item disabled">{{ employee?.phoneWork }}</div>
        </div>
    </div>
</div>

<!--Reports-->
<div class="content">
    <ng-container *ngFor="let reportsTo of employee?.reports">
        <app-org-accordion-item
            [employee]="reportsTo"
            [showPhoto]="showPhoto"
            [showName]="showName"
            [showPosition]="showPosition"
            [showDepartment]="showDepartment"
        ></app-org-accordion-item>
    </ng-container>
</div>
